import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, UrlSerializer } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgOtpInputModule } from 'ng-otp-input';
import { SharedModule } from './shared/shared.module';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
/* Add Amplify imports */
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';
import Amplify from 'aws-amplify';
// import awsconfig from '../aws-exports';
import { AuthService } from './shared/services/auth_service';
import { BasicService } from './shared/services/basic_service';
import { CommonService } from './shared/services/common_service';
import { HelperService } from './shared/services/helper_service';
import { Camera } from '@ionic-native/camera/ngx'
import { AppVersion } from '@ionic-native/app-version/ngx';
import { environment } from '../environments/environment';
import { FCM } from 'plugins/cordova-plugin-fcm-with-dependecy-updated/ionic/ngx/FCM';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
// deepLinking
import {Deeplinks} from '@ionic-native/deeplinks/ngx';
// socialsharing
import {SocialSharing} from '@ionic-native/social-sharing/ngx'
// session timeput
// import { IdleSessionTimeout } from "idle-session-timeout";
import { BnNgIdleService } from 'bn-ng-idle';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { AuthGuard } from './auth-guard';
import { CustomUrlSerializer } from './http-encoder';
import { CheckSuggestModule } from './check-suggest.module';
import { ErrorInterceptor } from './interceptors/error.interceptor';

Amplify.configure({
  Auth: {
    identityPoolId: environment.aws_cognito_identity_pool_id, // 'ap-south-1:c2ca58df-2491-43e0-afc0-22f1d2176666',
    region: environment.aws_cognito_region,
    userPoolId: environment.aws_user_pools_id,
    userPoolWebClientId: environment.aws_user_pools_web_client_id, //'9u8tpqtc01mernbn1pl9hvaaq',
    authenticationFlowType: 'CUSTOM_AUTH'
  },
  API: {
    endpoints: [
      {
        name: "matchesApi",
        endpoint: environment.matchesUrl,
        region: "ap-south-1"
      },
      {
        name: "profile",
        endpoint: environment.profileUrl,
        region: "ap-south-1"
      },
      {
        name: "walletApi",
        endpoint: environment.walletApi,
        region: "ap-south-1"
      },
      {
        name: "contestsApi",
        endpoint: environment.contestsApi,
        region: "ap-south-1"
      },
      {
        name: "fantasyApi",
        endpoint: environment.fantasyApi,
        region: "ap-south-1"
      },
      {
        name: "pointsServerApi",
        endpoint: environment.pointsServer,
        region: "ap-south-1"
      },
      {
        name: "pickemApi",
        endpoint: environment.pickemUrl,
        region: "ap-south-1"
      },
      {
        name: "downloadsApi",
        endpoint: environment.downloadsApiUrl,
        region: "ap-south-1"
      },
    ]
  }
});
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgOtpInputModule,
    AmplifyUIAngularModule,
    SharedModule,
    BrowserModule, IonicModule.forRoot(), AppRoutingModule,
    CheckSuggestModule,
  ],
  providers: [
    Camera,
    InAppBrowser,
    Deeplinks,
    SocialSharing,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    AuthService,
    BasicService,
    HelperService,
    AppVersion,
    CommonService,
    FCM,
    BackgroundMode,
    BnNgIdleService,
    SplashScreen,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }